<template>
  <div
    class="absolute left-0 top-0 z-10 h-6 rounded-t-md bg-white"
    style="right: 10px"
  />
</template>
<script>
export default {
  name: 'InsightsBoxScrollCover',
};
</script>
